import React from "react";

export const Logo = ({ className = "h-10" }) => (
  <img src="/logo.png" alt="SafeBuddy" className={className} draggable={false} />
);
